import reactDatePicker from "./react-datepicker";

export default `
  ${reactDatePicker}
`;
